
  <!-- Author: lss@ies. Html doc and Css style locked. -->
  <!-- このドキュメントを個人的に変更することは固く禁じられています。一度変更すると、サポートは提供しません。 -->

<template>
  <main-layout>

    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-07"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{$t('title.system.building.title')}}</label>
        <narrow-down
          @click="createBuilding"
          v-auth="{ auth: '010302'}"
          slot="create">
          {{$t('button.system.building.search.create')}}
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">

      <!-- 検索パネル -->
      <div class="panel-search">
        <el-form
          :model="query"
          :rules="rules"
          ref="ruleForm"
          class="search-form"
          label-position="left">

          <!-- オーナーID -->
          <div class="fm-row">
            <el-form-item
              prop="ownerEXId">
              <el-input
                maxlength="20"
                class="fm-input"
                v-model="query.ownerEXId"
                :placeholder="$t('label.system.building.search.query.ownerEXIdPlaceholder')">
              </el-input>
            </el-form-item>
            <sp-smart-lable-button class="fm-lb-btn" v-show="query.ownerName">
              {{query.ownerName}}
            </sp-smart-lable-button>
            <button-index @click="selectOwner" class="fm-st-btn limit-length">
              {{$t("button.common.select")}}
            </button-index>
          </div>

          <!-- ビルID -->
          <div class="fm-row">
            <el-form-item
              prop="buildingEXId">
              <el-input
                maxlength="20"
                class="fm-input"
                v-model="query.buildingEXId"
                :placeholder="$t('label.system.building.search.query.buildingEXIdPlaceholder')">
              </el-input>
            </el-form-item>
          </div>

          <!-- ビル名 -->
          <div class="fm-row">
            <el-form-item
              prop="buildingName">
              <el-input
                maxlength="50"
                class="fm-input"
                v-model="query.buildingName"
                :placeholder="$t('label.system.building.search.query.buildingNamePlaceholder')">
              </el-input>
            </el-form-item>
          </div>

          <!-- 検索ボタンエリア -->
          <div class="btn-area fm-row">
            <narrow-down @click="searchBuilding">
              {{$t('button.system.owner.search.search')}}
            </narrow-down>
            <cancel-narrow-down class="link-primary margin-left-8" @click="clearSearchParams">
              {{$t('button.system.building.search.clear')}}
            </cancel-narrow-down>
          </div>

        </el-form>
      </div>

      <!-- ページサイズ選択 -->
      <label v-show="isShow" class="list-title">{{$t('label.system.building.search.query.buildingList')}}</label>
      <div class="st-page-size" v-show="isShow">
        <label class="lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select
          v-model="query.pageSize"
          @change="changePageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>

      <!-- 検索結果テーブル -->
      <div ref="searchResultTable" id="search-result" class="margin-top-28">
        <building-search-result-beautify
          :result="searchResult.body"
          :isShow="this.isShow"
          @on-delete="deleteBuilding"
          @on-detail="detailBuilding"
          @on-edit="editBuilding"
          @on-setup-function="setupFunction"
          @on-elv-detail="elvDetail"
          @on-date-function="dateFunction"
          />
      </div>

      <br>

      <!-- ページネーション -->
      <pagination
        v-show="searchResult.totalCount > 0"
        :page-size="query.pageSize"
        :page-number="searchResult.pageNumber"
        :totalPage="searchResult.totalPage"
        :totalCount="searchResult.totalCount"
        @on-paging="handlePagingAction" />

      <!-- オーナー選択ポップアップ -->
      <owner-search-popup
        :visible.sync="showSelectOwnerDialog"
        :ownerExIdParam="query.ownerEXId"
        :ownerNameParam="query.ownerName"
        @on-selected="handlerOwnerSelected" />

      </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout"
import BuildingSearchResultBeautify from "@/components/system/BuildingSearchResultBeautify"
import SystemManageApi from "@/api/SystemManageApi"
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup"
import BuildingSearchRuleFactory from "@/rules/rule-building-search"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import headTitle from "@/components/common/head/head"
import SpSmartLableButton from "@/components/common/sp-smart-lable-button"
import Pagination from "@/components/common/pagination/Pagination"
import Menubar from "@/components/leftmenu/DashBoard"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import buttonIndex from "@/components/common/sp-smart-button/index";

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE_NUMBER = 1

export default {
  name: "BuildingSearch",
  components: {
    MainLayout: NewDesignLayout,
    BuildingSearchResultBeautify: BuildingSearchResultBeautify,
    Pagination: Pagination,
    OwnerSearchPopup: OwnerSearchPopup,
    headTitle: headTitle,
    cancelNarrowDown: cancelNarrowDown,
    narrowDown: narrowDown,
    SpSmartLableButton: SpSmartLableButton,
    Menubar: Menubar,
    buttonIndex
  },
  data() {
    return {
      //照会条件宣言
      query: {
        ownerEXId: null,
        ownerName: null,
        ownerId: null,
        buildingEXId: null,
        buildingName: null,
        buildingId: null,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER
      },
      //結果宣言に戻る
      searchResult: {
        pageNumber: 0,
        totalPage: 0,
        totalCount: 0,
        pageSize: 0,
        body: [
          {
            ownerEXId: null,
            ownerId: null,
            ownerName: null,
            buildingId: null,
            buildingName: null,
            buildingExId: null,
            postCode: null,
            address: null,
            aboveFloorCount: null,
            belowFloorCount: null,
            deleteFlag: null
          }
        ]
      },
      options: [
        {
          label: "10件",
          value: 10,
        },
        {
          label: "20件",
          value: 20,
        },
        {
          label: "50件",
          value: 50,
        },
      ],
      isSearching: false,
      tableLoadingAnim: null,
      showSelectOwnerDialog: false,
      rules: BuildingSearchRuleFactory.searchRules(this),
      isShow: false,
    }
  },
  methods: {
    changePageSize(){
      this.query.pageNumber = 1
      this.searchBuilding()
    },
    //検索
    searchBuilding: function () {
        this.$saveQueryParam("building_search_id", this.query)
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            if (!this.isSearching) {
              this.isSearching = true
              this.isShow = true
              this.showTableLoadingAnim()
              this.doneSearchBuilding()
            }
          } else {
            return false;
          }
        })
    },
    doneSearchBuilding(){
      SystemManageApi.searchBuilding({
        ownerId: this.query.ownerId,
        ownerEXId: this.query.ownerEXId,
        ownerName: this.query.ownerName,
        buildingEXId: this.query.buildingEXId,
        buildingId: this.query.buildingId,
        buildingName: this.query.buildingName,
        pageSize: this.query.pageSize,
        pageNumber: this.query.pageNumber
      })
      .catch((error)=>{
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if(statusErrorCodeMsg(data.statusCode, this)){
          this.searchResult.pageNumber = data.body.pageNumber
          this.searchResult.totalPage = data.body.totalPage
          this.searchResult.totalCount = data.body.totalCount
          this.query.pageSize = data.body.pageSize

          this.searchResult.body = []

          for(let index of data.body.body){
            this.searchResult.body.push({
              ownerEXId : index.ownerExId,
              ownerId : index.ownerId,
              ownerName : index.ownerName,
              buildingId : index.buildingId,
              buildingName : index.buildingName,
              buildingExId : index.buildingExId,
              postCode : index.postCode,
              address : index.postCode+"  "+index.address,
              aboveFloorCount : this.$t('label.system.building.search.query.buildingAbove')+
                                index.aboveFloorCount +
                                this.$t('label.system.building.search.query.floor')
                                +"/"+
                                this.$t('label.system.building.search.query.buildingUnderground')+
                                index.belowFloorCount +
                                this.$t('label.system.building.search.query.floor'),
              deleteFlag : index.deleteFlag
            })
          }

        }

      }).finally(() => {
        this.isSearching = false
        this.hideTableLoadingAnim()
      })
    },
    //クリア
    clearSearchParams: function () {
      this.$saveQueryParam("building_search_id", null)
      this.query.ownerEXId = null
      this.query.ownerName = null
      this.query.ownerId = null
      this.query.buildingEXId = null
      this.query.buildingName = null
      this.query.pageSize = DEFAULT_PAGE_SIZE
      this.query.pageNumber = DEFAULT_PAGE_NUMBER
      this.searchResult.totalPage = 0
      this.searchResult.totalCount = 0
      this.searchResult.body = []
      this.isShow = false
    },

    //削除バータン
    deleteBuilding: function (buildingId) {
      this.showTableLoadingAnim()
      SystemManageApi.deleteBuilding(buildingId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        let index = -1, owners = this.searchResult.body
        for (let i = 0; i < owners.length; i++) {
          if (owners[i].buildingId === buildingId) {
            index = i
            break
          }
        }
        owners.splice(index, 1)
        this.deleteSuccess()
        this.hideTableLoadingAnim()
      })
    },

    //照会バータン
    detailBuilding: function (buildingId) {
      this.$saveQueryParam("building_search_id", this.query)
      this.$router.push({
        name: 'system-building-detail',
        params: {
          buildingId: buildingId
        }
      })
    },

    //編集バータン
    editBuilding: function (buildingId) {
      this.$saveQueryParam("building_search_id", this.query)
      this.$router.push({
        name: 'system-building-edit',
        params: {
          buildingId: buildingId
        }
      })
    },

    //機能設定
    setupFunction: function (buildingId) {
      this.$router.push({
        name: 'system-FunctionSetUp',
        params: {
          buildingId: buildingId,
          id: "1"
        }
      })
    },

    //ELVグループ照会
    elvDetail: function (groupId) {
      this.$router.push({
        name: 'system-elvgroup-detail',
        params: {
          id: this.$route.name,
          groupId: groupId
        }
      })
    },

    //表示テーブルに動画をロードする
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#search-result",
          background: "#ebebe6"
        })
      }
    },

    //隠しフォームロードアニメーション
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close()
        this.tableLoadingAnim = null
      }
    },

    //ページ分け事件を処理する
    handlePagingAction: function(paging) {
      this.query.pageSize   = paging.pageSize
      this.query.pageNumber = paging.pageNumber
      this.searchBuilding();
      this.$refs.searchResultTable.scrollIntoView()
    },

    //オーナーサブ画面の選択
    selectOwner: function() {
      this.showSelectOwnerDialog = true
    },
    handlerOwnerSelected: function (owner) {
      this.query.ownerId = owner.id
      this.query.ownerName = owner.name
      this.query.ownerEXId = owner.exId
    },

    //設備一括導入
    machineImportBuilding: function (buildingId) {
      this.$router.push({
        name: 'system-building-deviceImport',
        params: {
          buildingId: buildingId
        }
      })
    },
    //ビル新規functionSetUp
    createBuilding: function () {
      this.$saveQueryParam("building_search_id", this.query)
      this.$router.push({
        name: 'system-building-create'
      })
    },

    //時間設定
    dateFunction: function (buildingId) {
      this.$router.push({
        name: 'system-times-setting',
        params: {
          buildingId: buildingId
        }
      })
    },

    //削除
    deleteSuccess: function() {
      this.$messageIotSuccess(this.$t('message.common.delete', {
        field: "ビル"
      }));
    },
    checkSearchConditions: function(query) {
      let isPast = false
      if((query.ownerEXId != "" ||
          query.ownerName != "" ||
          query.buildingEXId != "" ||
          query.buildingName != "")
          &&
          (query.ownerEXId != null ||
          query.ownerName != null ||
          query.buildingEXId != null ||
          query.buildingName != null)){

          isPast = true
      }
      return isPast
    }
  },
  watch: {
    query: {
      handler() {
        this.query.pageNumber = 1
      },
      deep: true
    }
  },
  mounted () {
    let queryObj = this.$getQueryParam("building_search_id")
    if(queryObj!=null){
      this.query = queryObj
      this.doneSearchBuilding()
      this.isShow = true
    }
  },
  created () {
    this.$authCheck("010301")
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "",
        title: "label.router.building",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

    this.searchResult.body = []
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    width: 188px;
    height: 32px;
  }
}

::v-deep .zdyInput {
  .el-input__inner {
    height: 26px;
    border-radius: 0px !important;
    color: #525250;
    border: 2px solid;
    border-color: #bce0fd;
    font-size: 12px;
  }
  .el-input__inner::placeholder {
    color: #bce0fd;
  }
  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #bce0fd;
  }
}

::v-deep .sp-table-cell{
  color: #6B6B69;
  font-weight: 100;
  font-size: 1px !important;
}
::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td{
  background: #F2F2ED;
}

::v-deep .el-input__suffix {
  top: 0px;
}
::v-deep .el-input__icon {
  line-height: 25px !important;
}
::v-deep .el-form-item__content{
  margin-left: 0em !important;
}

::v-deep .new-input-style-small {
  width: 120px;
  .el-input__inner{
    width: 120px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
::v-deep .st-page-size label{
  top: 0px;
}

.limit-length {
   width: 100px !important;
}
</style>
